import { Component, OnInit } from '@angular/core';
import {Individu, IndividuService} from "@Common/core/services";
import {roles} from "app/demat/common/enum/roles";
import {SubSink} from "@Common/core/utils/subsink";

@Component({
  selector: 'app-gestion-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilGestionComponent implements OnInit {
  subSink = new SubSink();
  isAdmin;
  isSuperviseur;
  adminView = false;
  selectedTabIndex = 0;
  constructor(private individuService: IndividuService,) {

  }

  ngOnInit() {
    this.subSink.sink = this.individuService.individu$.subscribe((individu: Individu) => {
      this.isAdmin = this.individuService.hasRole(individu, roles.admin);
      this.isSuperviseur = this.individuService.hasRole(individu, roles.superviseur);
    });
  }


}
